module.exports = __webpack_public_path__ + "static/media/makeitpigger.bb88be22.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Icons/makeitpigger.png
// module id = 1130
// module chunks = 0